import Italic from "@tiptap/extension-italic";

export default Italic.extend({
  addInputRules() {
    return [];
  },
  addPasteRules() {
    return [];
  },
});
